import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Frag } from "lib/@components/slot/frag"
import { Secure } from "lib/authorization/secure"
import Iconify from "minimals-template/components/Iconify"
import { AUTHORING_MANAGE_WORK_PACKAGES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function ProjectEditButton() {
    const { openProjectEdit, target: project } = useBoundContext()

    if (project?.archived) return null

    return (
        <Secure demand={AUTHORING_MANAGE_WORK_PACKAGES_DEMAND} fallback={<Frag />}>
            <Button
                onClick={handleClick}
                sx={{ color: "primary.main" }}
                startIcon={<Iconify icon="mdi:pencil-outline" />}
                data-cy="project-edit-button"
            >
                Edit
            </Button>
        </Secure>
    )

    function handleClick() {
        openProjectEdit(project)
    }
}
